/* 
 * CircleTransition.js
 * Created on 7-apr-2017
 * @author Swen Meeuwes for &ranj
 */

import AnimationOptions from "../AnimationOptions";
import AnimationFactory from "../AnimationFactory";

export default class CircleTransition {
    constructor(type) {
        this.type = type;
    }

    animate(screenNavigator, screen, animationOptions) {
        return new Promise(function (resolve, reject) {
            // If no animation options are specified, use the default animation options
            if (animationOptions === undefined)
                animationOptions = new AnimationOptions();

            var beginCircleScale = { scaleX: 0, scaleY: 0 };
            var endCircleScale = { scaleX: 0, scaleY: 0 };

            switch (this.type) {
                case AnimationFactory.CIRCLE_IN:
                    beginCircleScale.scaleX = beginCircleScale.scaleY = 0;
                    endCircleScale.scaleX = endCircleScale.scaleY = 1;
                    break;
                case AnimationFactory.CIRCLE_OUT:
                    beginCircleScale.scaleX = beginCircleScale.scaleY = 1;
                    endCircleScale.scaleX = endCircleScale.scaleY = 0;
                    break;
                default:
                    // Log warning
                    break;
            }

            // When the scale of the circle is equal to 1 it should cover the whole screen, which is a rectangle
            // This means that the radius of the circle should be equal to the diagonal of the rectangle divided by 2
            // We can use Pythagoras' Theorem to solve this problem
            var a = screenNavigator.getScreenWidth();
            var b = screenNavigator.getScreenHeight();
            var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));

            // Shout out to my boy Pythagoras
            var circleRadius = c / 2;

            // Create a circle shape to act as a mask
            var circleGraphics = new createjs.Graphics();
            circleGraphics.beginFill("#0F0").drawCircle(0, 0, circleRadius);
            var circle = new createjs.Shape(circleGraphics);
            circle.x = screenNavigator.getScreenWidth() / 2;
            circle.y = screenNavigator.getScreenHeight() / 2;

            // Set the circle to its begin size
            circle.set(beginCircleScale);

            // Mask the screen with the circle shape
            screen.mask = circle;

            // Execute the tween with the given animation options
            createjs.Tween
                .get(circle)
                .wait(animationOptions.delay)
                .to(endCircleScale, animationOptions.duration, animationOptions.ease)
                .call(function () {
                    // Handle callbacks in animation options
                    if (animationOptions.callbacks)
                        for (var i = 0; i < animationOptions.callbacks.length; i++) {
                            animationOptions.callbacks[i].call(this);
                        }
                    resolve();
                }.bind(this));
        }.bind(this));
    };
}